module.exports = __webpack_public_path__ + "assets/img/Future_Junier.54358972-ps.jpg";